/* eslint-disable react/no-danger */
import classNames from 'classnames';
import React from 'react';

import { addNonBreakingSpaces, cleanExternalLinks } from '../../lib/utils';

import Blocks from '../blocks/Blocks';
import Button from '../buttons/Button';
import CloseButton from '../buttons/Close';
import ArrowIcon from '../icons/Arrow';

import styles from '../../../styles/partials/popup.module.css';

interface PopupProps {
    page?: any | null;
    title?: string | null;
    description?: string | null;
    button?: { url: string; label: string } | null;
    blocks?: any[] | null;
    isSmall?: boolean;
    isGray?: boolean;
    className?: string | null;
    onClickClose?: (() => void) | null;
    children?: React.ReactNode;
}

function Popup({
    page = null,
    title = null,
    description = null,
    button = null,
    blocks = null,
    isSmall = false,
    isGray = false,
    className = null,
    children = null,
    onClickClose = null,
}: PopupProps) {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.isSmall]: isSmall,
                    [styles.isGray]: isGray,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                {title !== null ? (
                    <div className={classNames([styles.section, styles.titleSection])}>
                        <h1 className={styles.title}>{addNonBreakingSpaces(title)}</h1>
                    </div>
                ) : null}

                <div className={classNames([styles.body])}>
                    {description !== null ? (
                        <div className={classNames([styles.section, styles.textSection])}>
                            <div
                                className={styles.text}
                                dangerouslySetInnerHTML={{
                                    __html: cleanExternalLinks(description),
                                }}
                            />
                        </div>
                    ) : null}

                    {blocks !== null && blocks.length > 0 ? (
                        <div className={classNames([styles.section, styles.blocksSection])}>
                            <Blocks page={page} blocks={blocks} blocksAreSections />
                        </div>
                    ) : null}

                    {button !== null ? (
                        <div className={classNames([styles.section, styles.buttonSection])}>
                            <Button
                                href={button.url}
                                external
                                className={styles.button}
                                red
                                icon={<ArrowIcon className={styles.icon} />}
                                iconPosition="right"
                            >
                                {button.label}
                            </Button>
                        </div>
                    ) : null}
                    {children}
                </div>
            </div>
            {onClickClose !== null ? (
                <CloseButton onClick={onClickClose} className={styles.closeButton} />
            ) : null}
        </div>
    );
}

export default Popup;
